import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, OnInit} from "@angular/core";
import { BehaviorSubject, catchError, interval, map, Observable, of, shareReplay, startWith, switchMap, take, takeWhile, tap, throwError } from "rxjs";
import { BACKEND_URLS, BackendUrls } from "app/app.config";
import { ActivatedRoute, Router } from '@angular/router';
import { AllegatiService } from './allegati.service';
import { GMapService } from './gmap.service';
import * as uuid from 'uuid';
import { PagopaService } from './pagopa.service';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';


export interface AutocompleteOption {
    key: number | string;
    value?: string;
    label?: string;
  }




  export interface Istanza {
    id: string;
    codice?: string;
    tipo_id?:string;
    stato_id?:string;
    settore_id?:string;
    parent_id?:string;
    tipo?: {
        settore?: string;
        pagopa?:boolean;
        descrizione?:string;
        termine_procedimento?:number;
    };
    settore?: string;
    external_url?:string;
    stato?: string;
    stars?: number;
    int_nome?:string;
    del_nome?:string;
    int_cognome?:string;
    del_cognome?:string;
    data_presentazione?: string;
    data_protocollo?: string;
    numero_protocollo?: number;
    anno_protocollo?: number;
    numero_pratica?: string;
    data_termine?: string;
    data_chiusura?: string;
    nota_chiusura?: string;
    data_aggiornamento?: string;
    data_creazione?: string;
    termine?: number;
    is_new: boolean;
    step_index?: number;
    privacy?:boolean;
    tablename: string;
    jd?: any;
    lat?:number;
    lng?:number;
    geom?:any;
    geom_ewkt?:string;
    protocollo?: any;
    delega?:number;
    delegato?: any;
    intestatario?: any;
    pagopa?: boolean;
    giuridica?: boolean;
    created_by_id?:string;
    updated_at?:string;
  }

export interface Pagination {
  length: number;
  size: number;
  page: number;
  lastPage: number;
  startIndex: number;
  endIndex: number;
}

export interface IstanzePaginationResponse {
    message: string,
    meta: any,
    data:{
        items: Istanza[],
        total: number,
        page: number,
        size: number,
        pages: number,
        next_page: number,
        previous_page?: number
    }
  }


export interface SoggettoProtocollo {
    IndirizzoTelematico: string,
    Denominazione?: string,
    Nome?: string,
    Cognome?: string,
    TitoloDitta?: string,
    CodiceFiscaleDitta?: string,
    IndirizzoTelematicoDitta?: string,
    TipoMittente: string,
    CodiceFiscale: string,
    Titolo: string
}

export interface ParametroProtocollo {
    nome: string,
    valore: string
}

export interface ConfigProtocollo  {
    Soggetti:SoggettoProtocollo[],
    Flusso: string,
    Oggetto: string,
    Classifica: string,
    UO: string,
    Fascicolo?: {
      numero: string,
      anno: string
    },
    NumeroRegistrazione?: number,
    DataRegistrazione?: number,
    Parametri?: ParametroProtocollo[],
    TipoDocumento: string,
    Principale: string,
    Allegati: string[]
  }





@Injectable({
    providedIn: 'root'
})
export class IstanzeService implements OnInit {

    private _istanze: BehaviorSubject<Istanza[] | null> = new BehaviorSubject([]);

    public _istanza: BehaviorSubject<Istanza | null> = new BehaviorSubject(null);

    private _pagination: BehaviorSubject<Pagination | null> = new BehaviorSubject(null);

    private _filters: BehaviorSubject<any> = new BehaviorSubject({});

    private _visited: BehaviorSubject<string[] | null> = new BehaviorSubject([]);


    istanze: Istanza[];


    constructor(
        @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
        private _httpClient: HttpClient,
        private _activatedRoute: ActivatedRoute,
        public _allegatiService: AllegatiService,
        private _gmapService: GMapService,
        private _router: Router,

    )
    {

    }

    get visited$(): Observable<string[]> {
        return this._visited.asObservable();
    }

    get istanze$(): Observable<Istanza[]> {
        return this._istanze.asObservable();
    }

    get istanza$(): Observable<Istanza> {
        return this._istanza.asObservable();
    }

    get pagination$(): Observable<Pagination>{
        return this._pagination.asObservable();
    }

    get filters$(): Observable<string>{
        return this._filters.asObservable()
    }

    /*
    filters: {
        categorySlug$: BehaviorSubject<string>;
        query$: BehaviorSubject<any>;
        hideCessate$: BehaviorSubject<boolean>;
    } = {
        categorySlug$ : new BehaviorSubject('all'),
        query$        : new BehaviorSubject({'attiva':true}),
        hideCessate$: new BehaviorSubject(true),
    };
    */


    ngOnInit(): void {

    }

    setFilters(value:any){
        this._filters.next(value)
    }



    getIstanze(filters: any = {}, page: number = 1, size: number = 50, sort: string = 'data_aggiornamento', order: 'asc' | 'desc' | '' = 'desc'): Observable<Istanza[]> {

        return this._httpClient.post<Istanza[]>(`${this.backendUrls.backendApiUrl}/istanze/elenco`, filters,
            { params: { page, size, sort, order } }
        ).pipe(
            map(response => response["data"]),
            tap(data => this._istanze.next(data)),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 200) {
                    console.log(err['message']);
                }
                console.log(err['message']);
                this._istanze.next([]);
                return of([]);
            })
            //.............
        );
    }


    tornaCompilazione() {

        return this.istanza$.pipe(
            take(1),
            switchMap((istanza) => {
                const data = {
                    id:istanza.id,
                    stato_id: 'compilazione',
                    numero_protocollo: null,
                    data_protocollo: null,
                    anno_protocollo: null,
                    data_presentazione: null,
                    step_index: 0
                }

                // if (this.currentStep > this.formFields.fieldGroup.length) {
                //     this.currentStep = 1 //riparto da privacy
                // }

                //this.openSnackBar("Istanza in compilazione", 3000);
                //this.updateFormFields()
                return this.updateIstanza(data)

            })


            //tap((istanza)=>{console.log(istanza);this.model=istanza;this.updateDataComuni();this.updateFormFields()}),
            //tap((istanza)=>{this.model=istanza;this.updateDataComuni();this.updateFormFields();}),
            //concatMap(() => this._pagopaService.delPagamentiIstanza(this.model)),
            //concatMap(() => this._allegatiService.deleteByField(this.model.id, 'documento_riepilogo'))

        ).pipe(
            //switchMap((istanza) => this._pagopaService.delPagamentiIstanza(istanza)),
            //concatMap(() => this._allegatiService.deleteByField(this.model.id, 'documento_riepilogo'))
        )
    }




    getIstanzeSearch(filters:{}, page: number = 1, size: number = 50, sort: string = 'data_protocollo', order: 'asc' | 'desc' | '' = 'asc'):
        Observable<IstanzePaginationResponse>
    {

        return this._httpClient.post<IstanzePaginationResponse>(`${this.backendUrls.backendApiUrl}/istanze/search`,
        filters,
        {
             params: { page, size, sort, order }
        })
        .pipe(
            tap((response) =>
            {
                const result = response.data;
                const currentPag = {
                    length: result.total,
                    size: result.size,
                    page: result.page - 1,
                    lastPage: result.pages,
                    startIndex: 0,
                    endIndex: 12,
                };
                this._pagination.next(currentPag);
                this._istanze.next(response.data.items);
            }),
        );
    }

    exportCSV(filters:{})
    {
        return this._httpClient.post(`${this.backendUrls.backendApiUrl}/utils/csvexport?extra_data=0`,filters, { responseType: "blob" } )
    }

    exportSosta(filters:{})
    {
        return this._httpClient.post(`${this.backendUrls.backendApiUrl}/utils/sostaexport?extra_data=0`,filters, { responseType: "blob" } )
    }

    getIstanzaById(id: string): Observable<Istanza> {
      return this._httpClient
          .get<Istanza>(`${this.backendUrls.backendApiUrl}/istanze/${id}`)
          .pipe(
              map(response=>response["data"]),
              tap((data)=>this._istanza.next(data))
          );
    }

    getSerialById(id: string): Observable<Istanza> {
        return this._httpClient
            .get<Istanza>(`${this.backendUrls.backendApiUrl}/utils/serialdata/${id}`)
      }


    getIstanzeLast(limit: number): Observable<string[]> {
        return this._httpClient
            .get<string[]>(`${this.backendUrls.backendApiUrl}/istanze/last`, { params: { limit: 5 } })
            .pipe(
                tap((x) => {
                    this._visited.next(x)
                })
            );
    }


    createIstanza(settore:string, tipo:string, parentId: string=null, delega: number = 1): Observable<Istanza> {

        //const model={"rilascio2":1,"cognome":"Roberto","nome":"Starnini","cf":"STRRRT64A22D969F","comune":"GENOVA","provincia":"GENOVA","data_nato":"1964-01-22","email":"rstarnini@inwind.it","Pec":"rstarnini@inwind.it","cellulare":333333333,"Telefono":444444444,"rapporto":2,"orizzontale":"rrrrrrrrrrrrrrrr","gravidanza":true,"allegato_gravidanza":"rwqerwerqreqw","lavoratori_maternita":true,"lavoratori_figli":true,"tasks":[{"n":"2002-02-22"}],"lavoratori_disabilita":true,"documentazione":"ewqrqwreqwerqwr","distanza":true,"km":"444","avvio_presentazione":"2002-02-22","fine_presentazione":"2002-02-02","prestazione":1,"strumentale":"werwerwrewerwer","luoghi":"werwrwerwerwerwer","eventuali_note":"werwqrr qwer qjwre qweiropqwier qowiue rpoqweiur oqwiuerpqwoeruqwou rpqow iurpoq"}
        return this._httpClient.get(`${this.backendUrls.backendApiUrl}/utils/tipoistanza/${tipo}`)
            .pipe(
                map((ret: any)=>{
                    const newIstanza:Istanza = {
                        id: uuid.v4(),
                        is_new: true,
                        tablename: 'istanze',
                        settore_id: settore,
                        parent_id: parentId,
                        delega:delega,
                        tipo_id: tipo,
                        tipo: ret.descrizione || tipo,
                        external_url: ret.external_url,
                        step_index: 0,
                        pagopa: ret.pagopa || false,
                        giuridica: ret.giuridica || false,
                        stato_id: 'compilazione',
                        jd: {},
                    };
                    this._istanza.next(newIstanza);
                    return newIstanza;
                })
            );
      }


    //Da ricontrollare dopo aver messo uuid...
    createIstanzaxx(settore:string, tipo:string, parentId: string=null): Observable<Istanza> {

        //const model={"rilascio2":1,"cognome":"Roberto","nome":"Starnini","cf":"STRRRT64A22D969F","comune":"GENOVA","provincia":"GENOVA","data_nato":"1964-01-22","email":"rstarnini@inwind.it","Pec":"rstarnini@inwind.it","cellulare":333333333,"Telefono":444444444,"rapporto":2,"orizzontale":"rrrrrrrrrrrrrrrr","gravidanza":true,"allegato_gravidanza":"rwqerwerqreqw","lavoratori_maternita":true,"lavoratori_figli":true,"tasks":[{"n":"2002-02-22"}],"lavoratori_disabilita":true,"documentazione":"ewqrqwreqwerqwr","distanza":true,"km":"444","avvio_presentazione":"2002-02-22","fine_presentazione":"2002-02-02","prestazione":1,"strumentale":"werwerwrewerwer","luoghi":"werwrwerwerwerwer","eventuali_note":"werwqrr qwer qjwre qweiropqwier qowiue rpoqweiur oqwiuerpqwoeruqwou rpqow iurpoq"}
        let descTipo = tipo;
        const newIstanza:Istanza = {
            id: uuid.v4(),
            is_new: true,
            tablename: 'istanze',
            settore_id: settore,
            parent_id: parentId,
            tipo_id: tipo,
            step_index: 0,
            stato_id: 'compilazione',
            jd: {},
        };

        //Se integrazione prendo alcuni dati dalla pratica parent
        if(tipo=='integrazione' && parentId){
            return this.getIstanzaById(parentId).pipe(
                switchMap((istanza_parent)=>{
                    newIstanza.jd["numero_protocollo_parent"]=istanza_parent.numero_protocollo;
                    newIstanza.jd["data_protocollo_parent"]=istanza_parent.data_protocollo;
                    newIstanza.jd["numero_pratica_parent"]=istanza_parent.numero_pratica;
                    newIstanza.jd["intestatario_parent"]=`${istanza_parent.intestatario.cognome} ${istanza_parent.intestatario.nome}`;
                    if (istanza_parent.delegato){
                        newIstanza.jd["delegato_parent"]=`${istanza_parent.delegato.cognome} ${istanza_parent.delegato.nome}`;
                    }
                    this._istanza.next(newIstanza);
                    return of(newIstanza)

                })


            )


        }

        this._istanza.next(newIstanza);
        return of(newIstanza)

    }


    deleteIstanza(id: string): Observable<boolean> {

        console.log(id)
        return this.istanze$.pipe(
            take(1),
            switchMap((istanze) =>
                this._httpClient
                    .delete(`${this.backendUrls.backendApiUrl}/istanze/${id}`)
                    .pipe(

                        map((result) => result['data']),
                        map((deletedIstanza: Istanza) => {
                            // Find the index of the deleted attivita
                            const index = istanze.findIndex(
                                (item) => item.id === deletedIstanza.id
                            );

                            // Delete the attivita
                            if (index != -1) {
                              istanze.splice(index, 1);
                                // Update the attivitas
                                this._istanze.next(istanze);
                            }
                            // Return the deleted status
                            return index != -1;
                        })
                    )
            )
        );
    }


    updateIstanza(istanza: Istanza | Partial<Istanza>, refresh: boolean = false): Observable<Istanza> {
        // Rimuovi delegato se la qualità è 1
        if (istanza.delegato?.qualita === 1) {
            delete istanza.delegato;
        }

        // Seleziona il metodo API in base al tipo di operazione
        const callback = istanza.is_new
            ? this._httpClient.post<Istanza>(`${this.backendUrls.backendApiUrl}/istanze`, istanza)
            : this._httpClient.patch<Istanza>(`${this.backendUrls.backendApiUrl}/istanze`, istanza);

        return this.istanze$.pipe(
            take(1),
            switchMap(istanze =>
                callback.pipe(
                    map(result => result["data"]), // Estrai i dati dalla risposta API
                    map((updatedIstanza) => {
                        if (istanza.is_new) {
                            // Se è una nuova istanza, imposta i valori iniziali e fai il redirect
                            updatedIstanza.is_new = false;
                            updatedIstanza.step_index = 1;

                            // Aggiorna la lista locale
                            this._istanze.next([...istanze, updatedIstanza]);

                            // Redirect a una nuova URL
                            //this._router.navigate(['servizi-online', updatedIstanza.settore_id, updatedIstanza.codice]);
                            return updatedIstanza; // Ritorna l'istanza aggiornata
                        }

                        // Aggiorna l'oggetto esistente nella lista
                        const index = istanze.findIndex(item => item.id === updatedIstanza.id);
                        if (index !== -1) {
                            istanze[index] = updatedIstanza;
                            this._istanze.next(istanze); // Aggiorna la lista
                        }

                        // Aggiorna l'oggetto corrente se richiesto
                        if (refresh) {
                            this._istanza.next(updatedIstanza);
                        }

                        // Pulisci sessionStorage
                        sessionStorage.removeItem("__tchd");

                        return updatedIstanza; // Ritorna l'istanza aggiornata
                    })
                )
            ),
            catchError((error) => {
                console.error("Errore durante l'aggiornamento dell'istanza:", error);
                return throwError(error); // Gestione dell'errore
            })
        );
    }



    inoltraIstanza(): Observable<Istanza> {

        return this.istanza$.pipe(
            take(1),
            switchMap(istanza => this._httpClient.patch<Istanza>(`${this.backendUrls.backendApiUrl}/utils/inoltra/${istanza.id}`,
            {}).pipe(
                map(result=>result["data"]),
                tap((updatedIstanza) =>
                {
                    // Find the index of the updated istanza
                    //const index = istanze.findIndex(item => item.id === updatedIstanza.id);

                    //istanze[index]=updatedIstanza
                    // Update the lista
                    //???????????this.istanze$.subscribe()
                    //this._istanze.next(istanze);
                    this._istanza.next(updatedIstanza);
                    this._istanze.next(updatedIstanza);


                    // Return the updated product
                    //return updatedIstanza;
                })
            )),
            catchError((err: Response) => {
                console.log(err)
                if (err.status === 200) {
                    console.log(err['message']);
                }
                return of(null);
            })
        )
    }


    protocollaIstanza(configProtocollo:ConfigProtocollo, istanza_id: string): Observable<Istanza> {

        return this.istanze$.pipe(
            take(1),
            switchMap(istanze => this._httpClient.patch<Istanza>(`${this.backendUrls.backendApiUrl}/utils/protocolla/${istanza_id}`,configProtocollo).pipe(
                map(result=>result["data"]),
                map((updatedIstanza) =>
                {
                    // Find the index of the updated anagrafica
                    const index = istanze.findIndex(item => item.id === updatedIstanza.id);

                    //updatedIstanza.numero_protocollo=9999
                    //updatedIstanza.data_protocollo='2023-12-12'
                    //updatedIstanza.stato='protocollata'

                    istanze[index]=updatedIstanza

                    // Update the lista
                    //???????????this.istanze$.subscribe()
                    this._istanze.next(istanze);

                    // Return the updated product
                    return updatedIstanza;
                })
            )),
        )
    }


    verificaProtocollo(): Observable<Istanza> {

        const istanza_id = this._istanza.value.id

        return this._httpClient
        .get<any>(`${this.backendUrls.backendApiUrl}/utils/checkprotocollo/${istanza_id}`)
        .pipe(
            map((result) => result['data']),
            catchError((err: Response) => {
                if (err.status === 200) {
                    console.log(err['message']);
                }
                return of(null);
            })
        )

    }

    checkProtocollo(){
        const istanza = this._istanza.value;
        interval(5000)
            .pipe(
                startWith(0), // Esegui subito il controllo iniziale
                switchMap(() => this.verificaProtocollo()),
                takeWhile((res) => {
                    // Continua finché il numero di protocollo non è valorizzato o lo stato è "errore-protocollo"
                    //console.log('Controllo numero protocollo:', res);
                    return istanza.stato_id === 'errore-protocollo' || !res.numero_protocollo;
                }, true) // `inclusive` per includere l'ultimo valore
            )
            .subscribe({
                next: (res) => {
                    if (res.numero_protocollo) {
                        location.reload()
                        //console.log('Protocollo trovato:', res.numero_protocollo);
                        // Aggiorna il modello
                        istanza.numero_protocollo = res.numero_protocollo;
                        istanza.data_protocollo = res.data_protocollo;
                        this._istanza.next(istanza)
                    }
                },
                error: (err) => {
                    console.error('Errore durante il polling del protocollo:', err);
                },
                complete: () => {
                    console.log('Polling completato: protocollo trovato o condizione interrotta.');
                },
            });

    }



    setAzioneSuPagamento(azione:string):any{

        this.istanza$.pipe(
            take(1),
            tap(console.log)
        )

        return of(true)



    }


}
